/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const uniq = (array, iteratee) => array.filter((item, i, self) => self.findIndex((it) => iteratee(it) === iteratee(item)) === i);

export default uniq;


// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/util/uniq.js